{
  "#DN_ROSTER": {
    "TITLE": "Fahrzeugplan",
    "VIEW_TAB_TITLE": "Ansicht",
    "SELECTION_TAB_TITLE": "Auswahl",
    "REFRESH": "Aktualisieren",
    "DELETE": "Löschen",
    "SELECTED": "ausgewählt",
    "ARTIFACTS_LIST": {
      "ORDERS": "Aufträge",
      "PURCHASE_ORDERS": "Bestellungen",
      "NO_ORDERS": "Keine Aufträge",
      "NO_PURCHASE_ORDERS": "Keine Bestellungen",
      "SEARCH_ORDERS": "Aufträge suchen",
      "SEARCH_PURCHASE_ORDERS": "Bestellungen suchen",
      "NO_ADDRESS": "keine Adresse angegeben",
      "RELOAD": "aktualisieren",
      "EXPAND_COLLAPSE_ALL": "Alle Einträge erweitern/zusammenklappen"
    },
    "VIEW_TYPE_LABEL": "Zeitraum",
    "VIEW_TYPE_DAY": "Tag",
    "VIEW_TYPE_WORK_WEEK": "Arbeitswoche",
    "VIEW_TYPE_WEEK": "Woche",
    "VIEW_TYPE_MONTH": "Monat",
    "DETAILS": "Details",
    "DETAILS_COMPACT": "Kompakt",
    "DETAILS_ALL": "Details",
    "DETAIL_LABELS": {
      "DESTINATION": "Ziel",
      "WEIGHT": "Gewicht",
      "LENGTH": "Länge",
      "USER": "Sachbearbeiter",
      "COMMENT": "Kommentar",
      "CHANGED_AT": "Geändert"
    },
    "IMPORT": "Importieren",
    "EXPORT": "Exportieren",
    "MAIL": "Avisierung",
    "MAIL_TOOLTIP": "Avisierung senden",
    "MAIL_TOOLTIP_DISABLED": "Wählen Sie geschlossene Einträge aus, für die Sie eine Avisierung versenden wollen.",
    "MESSAGES": {
      "CREATE_SUCCESS": "Planeintrag wurde erfolgreich erstellt.",
      "UPDATE_SUCCESS": "Planeintrag wurde erfolgreich aktualisiert.",
      "DELETE_SUCCESS": "Planeintrag wurde erfolgreich gelöscht.",
      "DELETE_SOME_SKIPPED": "Einige ausgewählte Einträge konnten nicht gelöscht werden.",
      "MAIL_SUCCESS": "Avisierung wurde erfolgreich versendet.",
      "MAIL_SUCCESS_COUNT": "Avisierung(en) erfolgreich versendet",
      "MAIL_FAILED_COUNT": "fehlgeschlagen",
      "IMPORT_SUCCESS": "Import erfolgreich abgeschlossen",
      "EXPORT_SUCCESS": "Exportieren erfolgreich",
      "EXPORT_DAY_SUCCESS": "Tag wurde erfolgreich abgeglichen."
    },
    "CREATE_EVENT": "Eintrag erstellen",
    "EDIT_EVENT": "Eintrag bearbeiten",
    "RESOURCE_TYPES": {
      "VEHICLE": "Fahrzeuge",
      "VKFORG": "Verkaufsorganisationen"
    },
    "DIALOG": {
      "GROB": "Grob-Planung",
      "DETAIL": "Detail-Planung",
      "EXPORT_TITLE": "Exportzeitraum wählen"
    },
    "STATUS": {
      "NOT_PICKED": "Nicht Kommissioniert",
      "FULLY_PICKED": "Vollständig Kommissioniert",
      "PARTIALLY_PICKED": "Teilweise Kommissioniert"
    }
  },
  "ROSTERDELIVERY": {
    "VALIDATION": {
      "PLAN_IN_PAST": "{{belegart}} {{belegnummer}}: Planungsdatum ({{planDate}}) liegt in der Vergangenheit (heute: {{today}})."
    },
    "EXPORT": {
      "FIELD_MISSING": "{{belegart}} {{belegnummer}} – Pflichtfelder fehlen bei {{bereich}}: {{fields}}"
    },
    "NOTIFICATION": {
      "NOT_SYNCED": "Fahrzeugplan {{planId}} wurde noch nicht von Tourbo.route rückabgeglichen."
    }
  }
}
